import { mapActions, mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import rotasStore from '../../../../store'

export const rotasMixin = {
  props: {
    acao: Object,
  },
  data: () => ({
    tags: [],
    centroDeCusto: [],
    alliasRegexOrigem: [{ value: '', text: '' }],
    alliasRegexDestino: [{ value: '', text: '' }],
    showSkeleton: true,
  }),
  computed: {
    ...mapGetters('rotasMixinStore', ['getCentroDeCustos', 'getRegex', 'getTags','getAudios']),

    todasTagsSelecionadas() {
      return this.form.acao.tag.length === this.tags.length
    },
    alugmasTagsSelecionadas() {
      return this.form.acao.tag.length > 0 && !this.todasTagsSelecionadas
    },
    iconTags() {
      if (this.todasTagsSelecionadas) return 'mdi-close-box'
      if (this.alugmasTagsSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    registerVuexModule(this.$store, 'rotasMixinStore', rotasStore)
  },

  methods: {
    ...mapActions('rotasMixinStore', ['listarCentroDeCustos', 'listarRegex', 'listarTags','listarAudios']),

    toggleTags() {
      this.$nextTick(() => {
        if (this.todasTagsSelecionadas) {
          this.form.acao.tag.splice(0)
        } else {
          this.form.acao.tag.splice(0)
          this.form.acao.tag = this.tags.map(operador => operador.value)
        }
      })
    },

    makeFormulario() {
      const copyForm = Object.assign({}, this.acao)
      const copyFormActions = Object.assign({}, this.acao.acao)

      delete copyForm.acao
      const keysCopyForm = Object.getOwnPropertyNames(copyForm)
      const keysCopyFormActions = Object.getOwnPropertyNames(copyFormActions)

      keysCopyForm.forEach(key => {
        this.form[`${key}`] = this.acao[`${key}`]
      })

      keysCopyFormActions.forEach(keyAction => {
        this.form.acao[`${keyAction}`] = this.acao.acao[`${keyAction}`]
      })
    },

    getItemsSelectCentroDeCusto() {
      this.centroDeCusto = this.getCentroDeCustos.map(centroDeCustos => ({
        value: centroDeCustos._id,
        text: `${centroDeCustos.codigo} - ${centroDeCustos.description}`,
      }))
    },

    getItemsSelectRegexOrigemEDestino() {
      this.getRegex.forEach(allias => {
        this.alliasRegexOrigem.push({ value: allias._id, text: allias.description })
        this.alliasRegexDestino.push({ value: allias._id, text: allias.description })
      })
    },

    getItemsSelectTags() {
      this.tags = this.getTags.map(tag => ({ text: tag.description, value: tag._id }))
    },

  
  },

  watch: {
    form: {
      deep: true,
      handler(novo) {
        this.$emit('form', novo)
        this.$emit('error', this.$v)
      },
    },
  },
}
